import { render } from "./ConfirmNextSection.vue?vue&type=template&id=3defad48"
import script from "./ConfirmNextSection.vue?vue&type=script&lang=js"
export * from "./ConfirmNextSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__